import React, {
  useEffect,
  useState
} from "react";

import axios from "axios";

import {
  API_URL
} from "../config/api";


function JoinCircle() {

  const [email, setEmail] =
  useState("");

const [message, setMessage] =
  useState("");

const [messageType, setMessageType] =
  useState("");

const [submitting, setSubmitting] =
  useState(false);

const [cooldown, setCooldown] =
  useState(0);

  useEffect(() => {

  if (cooldown <= 0) {
    return undefined;
  }

  const timer =
    window.setTimeout(
      () => {
        setCooldown(
          previous =>
            Math.max(
              previous - 1,
              0
            )
        );
      },
      1000
    );

  return () =>
    window.clearTimeout(timer);

}, [cooldown]);

  const handleSubmit = async (event) => {

  event.preventDefault();

  if (
    submitting ||
    cooldown > 0
  ) {
    return;
  }

  setMessage("");
  setMessageType("");
  setSubmitting(true);

  try {

    const response =
      await axios.post(
        `${API_URL}/api/community/verification/start`,
        {
          email
        }
      );

    setMessage(
      response.data?.message ||
      "If this email is eligible, a verification link will be sent shortly."
    );

    setMessageType(
      "success"
    );

    /*
     * SECURITY / ABUSE CONTROL:
     * Prevent repeated button presses
     * from this browser.
     *
     * The backend independently enforces
     * its own cooldown and rate limits.
     */
    setCooldown(60);

  } catch (error) {

    setMessage(
      error.response?.data?.message ||
      "Unable to send the verification email right now. Please try again."
    );

    setMessageType(
      "error"
    );

  } finally {

    setSubmitting(false);

  }

};


  return (

    <main className="join-circle-page">

      <section className="join-circle-panel">

        <p className="join-circle-eyebrow">
          Beyond the Feed
        </p>

        <h1>
          Join the Circle
        </h1>

        <p className="join-circle-intro">
          Stay connected with Chatra Sangbad.
          Join the Circle with your email.
        </p>

        <form
  className="join-circle-form"
  onSubmit={handleSubmit}
>

  <div className="join-circle-field">

    <label htmlFor="circle-email">
      Email
      <span aria-hidden="true">
        {" "}*
      </span>
    </label>

    <input
      id="circle-email"
      type="email"
      value={email}
      onChange={(event) =>
        setEmail(
          event.target.value
        )
      }
      maxLength={254}
      autoComplete="email"
      inputMode="email"
      placeholder="you@example.com"
      required
    />

  </div>


  <p
    style={{
      margin: "0",
      color: "#666666",
      fontSize: "14px",
      lineHeight: "1.6"
    }}
  >
    We will send a verification link
    to this email address.
  </p>


  <button
    type="submit"
    className="join-circle-submit"
    disabled={
      submitting ||
      cooldown > 0
    }
  >

    {submitting
      ? "Sending..."
      : cooldown > 0
        ? `Send again in ${cooldown}s`
        : "Verify Email"}

  </button>


  {message && (

    <div
      className={
        `join-circle-message ${
          messageType === "success"
            ? "join-circle-message--success"
            : "join-circle-message--error"
        }`
      }
      role={
        messageType === "error"
          ? "alert"
          : "status"
      }
    >
      {message}
    </div>

  )}

</form>

      </section>

    </main>

  );

}


export default JoinCircle;